/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { TopicType } from '@api';

// TODO: Remove this mock and uncomment the wretchRequest implementations below
// once the watchlist/v1/topics endpoints are live on the BE. Seed
// `INITIAL_FOLLOWED` with real theme/geography IDs to drive the FE flows
// (back-nav, unfollow diff, etc.) against a pre-populated state. Fake IDs will
// cause downstream detail fetches (e.g. useThemesArray) to fail, so use real
// ones.
const INITIAL_FOLLOWED: Record<TopicType, string[]> = {
  theme: [],
  geography: [],
};

const followedByType = new Map<TopicType, Set<string>>(
  (Object.entries(INITIAL_FOLLOWED) as [TopicType, string[]][]).map(
    ([type, codes]) => [type, new Set(codes)]
  )
);

const getFollowedSet = (type: TopicType) => {
  const existing = followedByType.get(type);

  if (existing) {
    return existing;
  }

  const created = new Set<string>();
  followedByType.set(type, created);
  return created;
};

export const getTopics = (type: TopicType, _signal?: AbortSignal) =>
  Promise.resolve({ values: Array.from(getFollowedSet(type)) });

export const getTopic = (
  type: TopicType,
  code: string,
  _signal?: AbortSignal
) => Promise.resolve({ followed: getFollowedSet(type).has(code) });

export const postTopic = (type: TopicType, code: string) => {
  const set = getFollowedSet(type);
  set.add(code);
  return Promise.resolve({ values: Array.from(set) });
};

export const deleteTopic = (type: TopicType, code: string) => {
  const set = getFollowedSet(type);
  set.delete(code);
  return Promise.resolve({ values: Array.from(set) });
};

// import { topics } from '@api';
// import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';
//
// export const getTopics = (type: TopicType, signal?: AbortSignal) =>
//   wretchRequest(topics.getTopics.path(type), {
//     schema: topics.getTopics.schema,
//     signal,
//   });
//
// export const getTopic = (
//   type: TopicType,
//   code: string,
//   signal?: AbortSignal
// ) =>
//   wretchRequest(topics.getTopic.path(type, code), {
//     schema: topics.getTopic.schema,
//     signal,
//   });
//
// export const postTopic = (type: TopicType, code: string) =>
//   wretchRequest(topics.postTopic.path(type, code), {
//     method: 'post',
//     schema: topics.postTopic.schema,
//   });
//
// export const deleteTopic = (type: TopicType, code: string) =>
//   wretchRequest(topics.deleteTopic.path(type, code), {
//     method: 'delete',
//     schema: topics.deleteTopic.schema,
//   });
